/**
 * Action State
 */
class State {
  constructor(parent) {
    this.parent = parent
  }

  enter() {}
  exit() {}
  update() {}
}

export default State
